import { Record } from 'immutable';
import { LookupAddress } from '../../event/models/lookup-address';

const PropertyLookupDetailQueryRecord = Record({
  chain: null,
  brand: null,
  propertyId: null,
  name: null,
  address: new LookupAddress({}),
  manuallyAdded: null
});

export class PropertyLookupDetailQuery extends PropertyLookupDetailQueryRecord {
  chain: string;
  brand: string;
  propertyId: string;
  name: string;
  address: LookupAddress;
  manuallyAdded: boolean;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/models/property-lookup-detail-query.ts